import '/builds/gitlab/gitlab-ee/app/assets/javascripts/pages/projects/index.js?vue3';
import { initHandRaiseLead } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/hand_raise_leads/hand_raise_lead/index.js?vue3';
import EndOfTrialModal from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/end_of_trial/components/end_of_trial_modal.vue?vue3';
import { initSimpleApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/helpers/init_simple_app_helper.js?vue3';

initHandRaiseLead();
initSimpleApp('#js-end-of-trial-modal', EndOfTrialModal, { withApolloProvider: true });
